import { Button, Form, Input, message, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "../Styles/AddProducts.css";
import React, { useEffect } from "react";
import { apiClient } from "../Api/AllApi";


const UpdateCustomer = ({ storeCustomer }) => {
  const { t } = useTranslation();
  const { Option } = Select;
  const { id } = useParams();
  const product = Array.isArray(storeCustomer)
    ? storeCustomer.find((item) => item.id === parseInt(id))
    : null;

  const [form] = Form.useForm();

  useEffect(() => {
    if (product) {
      try {
        form.setFieldsValue({
          name: product.name || "",
          type: product.type || "",
          phone_number: product.phone_number || "",
          email: product.email || "",
        });
      } catch (error) {
        console.error("Error parsing product name or description:", error);
      }
    }
  }, [product, form]);
  const onFinish = async (values) => {
    try {
      const updatedValues = {
        ...values,
        name: values.name,
        type: values.type,
        phone_number: values.phone_number,
        email: values.email,
      };

      const response = await apiClient.put(
        `/customers/${id}`,
        updatedValues
      );

      if (response.status === 200) {
        message.success(t("successfully_updated"));
        window.location.href = "/GetCustomer";
      }
    } catch (error) {
      console.error("Error updating customer:", error);
      message.error(t("failed_to_update"));
    }
  };

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const onFinishFailed = () => {
    message.error(t("error"));
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("UpdateProducts")}
      </h1>

      <Form
        form={form}
        {...layout}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        style={{ fontSize: "18px" }}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          name="name"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("name")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("enter_customer")}
          />
        </Form.Item>
        <Form.Item
          name="email"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("email")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("email")}
          />
        </Form.Item>
        <Form.Item
          name="phone_number"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("phone")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder={t("enterPhone")}
          />
        </Form.Item>
        <Form.Item
          name="type"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("type")}
            </span>
          }
        >
          <Select
            style={{ width: "40%", textAlign: "left" }}
            placeholder={t("select_type")}
          >
            <Option value="Company">{t("company")}</Option>
            <Option value="Individual">{t("individual")}</Option>
            <Option value="Organization">{t("organization")}</Option>
          </Select>
        </Form.Item>

        <Form.Item label=".">
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            type="primary"
            danger
            onClick={() => (window.location.href = "/GetCustomer")}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdateCustomer;
